import React, { useEffect, useState } from 'react';
import {
  Progress,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { PiNotebook } from 'react-icons/pi';
import { FaCircleCheck, FaCircleXmark } from 'react-icons/fa6';
import { Job } from '@ais-ui/websockets';
import { useDateTimeFormat } from '../conversions/useDateFormat';

interface ReportItemProps {
  report: Job;
  setSelectedJob: React.Dispatch<React.SetStateAction<Job | null>>;
}

export const ReportItem = React.memo(
  ({ report, setSelectedJob }: ReportItemProps) => {
    const [progress, setProgress] = useState<number>(report.percentComplete);
    const { formatDateTimeWithTimeZone } = useDateTimeFormat();

    const failureReason = report.failureReason.replace(': internal error', '');

    useEffect(() => {
      const timer = setTimeout(() => setProgress(report.percentComplete), 500);
      return () => clearTimeout(timer);
    }, [report.percentComplete]);

    return (
      <div className="space-y-4 w-full">
        <Tooltip>
          <TooltipTrigger asChild>
            <div
              onClick={() => setSelectedJob(report)}
              className="flex items-center group/report-item justify-between py-3 px-4 mx-2 rounded-md hover:cursor-pointer hover:bg-secondary transition-colors"
            >
              <div className="flex items-center">
                <PiNotebook className="h-6 w-6 mr-2 group-hover/report-item:text-primary" />
                <div className="ml-2 space-y-1">
                  <p className="text-sm font-medium leading-none group-hover/report-item:underline">
                    {report.name}
                  </p>
                  <p className="text-sm text-muted-foreground group-hover/report-item:underline">
                    {formatDateTimeWithTimeZone(report.creationdate)}
                  </p>
                </div>
              </div>

              {(report.status === 'FINISHED' ||
                report.status === 'FINISHED_SCHEDULED') && (
                <FaCircleCheck className="text-success" />
              )}
              {report.status === 'FAILED' && (
                <FaCircleXmark className="text-destructive" />
              )}
            </div>
          </TooltipTrigger>
          {failureReason && <TooltipContent>{failureReason}</TooltipContent>}
        </Tooltip>
        {report.status !== 'FINISHED' &&
          report.status !== 'FAILED' &&
          report.status !== 'FINISHED_SCHEDULED' && (
            <div className="space-y-2">
              <p>{progress} %</p>
              <Progress value={progress} className="" />
            </div>
          )}
      </div>
    );
  }
);

ReportItem.displayName = 'ReportItem';
